import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';

// third-party
// import PerfectScrollbar from 'react-perfect-scrollbar';
// import { 
//   // BrowserView,
//    MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import MenuCard from './MenuCard';
import { drawerWidth } from 'store/constant';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const drawer = (
    <>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
          <LogoSection />
        </Box>
      </Box>
      {/* <BrowserView> */}
      {
        isMobile?
        <Box
          component="div"
          className='sidebar-content'
          style={{
            paddingLeft: '16px',
            paddingRight: '16px',
            border: '1px solid #d4d4d4'
          }}
        >
          <MenuCard />
          <MenuList />

        </Box>
      :
        <Box sx={{ px: 2 }}>
          <MenuList />
          <MenuCard />

        </Box>
      }
        
    </>
  );

  const container = window !== undefined ? () => window.document.body : undefined;

  const effectiveDrawerOpen = matchUpMd ? true : drawerOpen;


  return (
    <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="mailbox folders">
      <Drawer
        container={container}
        variant={matchUpMd ? 'persistent' : 'temporary'}
        anchor="left"
        open={effectiveDrawerOpen}
        onClose={drawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            borderRight: 'none',
            display: 'flex',
            flexDirection: 'column',
            [theme.breakpoints.up('md')]: {
              top: '88px',
              height: 'calc(100% - 88px)'
            }
          }
        }}
        
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object
};

export default Sidebar;
